import { Table } from "evergreen-ui";
import React from "react";
import ReactDatePicker from "react-datepicker";
import { AbstractTableBodyCellRenderer } from "./AbstractTableBodyCellRenderer";
import { utcToEastern, easternToUtc } from "../../../EasternTime";

import "react-datepicker/dist/react-datepicker.css";
import "../../styles/TableView.css";

export class TableDateTimePickerCellRenderer<T> extends AbstractTableBodyCellRenderer<T> {
    protected getMemoizedComponent(): React.FunctionComponent {
        const {
            columnConfig,
            cellValue,
            onCellChanged,
            id
        } = this.input;
        return React.memo(() => {
            let initialDate: Date | null;
            try {
                if (cellValue === "") {
                    initialDate = null;
                } else {
                    const parsed = new Date(cellValue);
                    initialDate = isNaN(parsed.getTime()) ? null : utcToEastern(parsed);
                }
            } catch (e: any) {
                initialDate = null;
            }

            return (
                <Table.Cell>
                    <ReactDatePicker
                        className={"jc-date-picker-cell"}
                        selected={initialDate}
                        dateFormat={"MMM d, yyyy h:mm aa"}
                        showTimeSelect
                        timeFormat={"h:mm aa"}
                        timeIntervals={15}
                        onChange={(date: Date | null) => {
                            if (onCellChanged) {
                                onCellChanged(
                                    id,
                                    columnConfig.columnName as keyof T,
                                    date ? easternToUtc(date).toISOString() : null,
                                );
                            }
                        }}
                        popperClassName={"jc-date-picker-popover"}
                        calendarClassName={"jc-date-picker-popover-calendar"}
                    />
                </Table.Cell>
            );
        });
    }
}
